import { Calendar, Download, Menu, Search } from 'lucide-react';
import { User } from '../firebase';

interface HeaderProps {
  user: User;
  onSearchClick: () => void;
  onMenuClick: () => void;
  onExportClick: () => void;
  selectedMonth: string;
  onMonthChange: (month: string) => void;
  hasUnreadMessages?: boolean;
}

export function Header({
  user,
  onSearchClick,
  onMenuClick,
  onExportClick,
  selectedMonth,
  onMonthChange,
  hasUnreadMessages,
}: HeaderProps) {
  return (
    <header className="fixed top-0 right-0 left-0 z-50 flex items-center justify-between bg-zinc-50/80 px-6 py-6 backdrop-blur-xl transition-colors duration-300 dark:bg-zinc-950/80">
      <div className="flex items-center gap-3">
        <div className="flex h-10 w-10 items-center justify-center overflow-hidden rounded-xl">
          <img
            src="/images/logo-dark.webp"
            alt="Kówópé Logo"
            className="h-full w-full object-cover dark:hidden"
          />
          <img
            src="/images/logo-white.webp"
            alt="Kówópé Logo"
            className="hidden h-full w-full object-cover dark:block"
          />
        </div>
        <div className="space-y-0.5">
          <h1 className="text-xl font-bold tracking-tight text-zinc-900 dark:text-zinc-100">
            Kówópé
          </h1>
          <p className="text-[10px] font-medium tracking-widest text-zinc-400 uppercase">
            {user.displayName?.split(' ')[0]}'s Finance
          </p>
        </div>
      </div>

      <div className="flex items-center gap-1 rounded-2xl border border-zinc-100 bg-white p-1.5 shadow-sm dark:border-zinc-800 dark:bg-zinc-900">
        <div className="relative rounded-xl p-2.5 text-zinc-400 transition-colors hover:bg-zinc-100 hover:text-zinc-900 dark:hover:bg-zinc-800 dark:hover:text-zinc-100">
          <input
            type="month"
            value={selectedMonth}
            onChange={(e) => onMonthChange(e.target.value)}
            className="absolute inset-0 z-10 h-full w-full cursor-pointer opacity-0"
          />
          <Calendar className="h-5 w-5" />
        </div>
        <button
          onClick={onSearchClick}
          className="rounded-xl p-2.5 text-zinc-400 transition-colors hover:bg-zinc-100 hover:text-zinc-900 dark:hover:bg-zinc-800 dark:hover:text-zinc-100"
        >
          <Search className="h-5 w-5" />
        </button>
        <button
          onClick={onExportClick}
          className="hidden rounded-xl p-2.5 text-zinc-400 transition-colors hover:bg-zinc-100 hover:text-zinc-900 dark:hover:bg-zinc-800 dark:hover:text-zinc-100"
        >
          <Download className="h-5 w-5" />
        </button>
        <div className="mx-1 h-4 w-px bg-zinc-200 dark:bg-zinc-700"></div>
        <button
          onClick={onMenuClick}
          className="rounded-xl p-2.5 text-zinc-400 transition-colors hover:bg-zinc-100 hover:text-zinc-900 dark:hover:bg-zinc-800 dark:hover:text-zinc-100"
        >
          <div className="relative">
            <Menu className="h-5 w-5" />
            {hasUnreadMessages && (
              <span className="absolute -top-0.5 -right-0.5 h-2.5 w-2.5 rounded-full border-2 border-white bg-rose-500 dark:border-zinc-900" />
            )}
          </div>
        </button>
      </div>
    </header>
  );
}
